import { useState, useEffect } from "react";
import "./style.scss";
import { useWPAjax } from "../../../../../wp-utils/v1";

const Aside = ({ state, page, setPage }) => {
  const [jobMenuOpen, setJobMenuOpen] = useState(false);
  const { data, refetch: logout, isLoading, error } = useWPAjax("ajax_request_handler", { nonce: state.nonce, model: "Users", method: "logout" }, true);
  const { auth, members } = state;

  useEffect(() => {
    if (!["jobs", "new-job-post"].includes(page)) {
      setJobMenuOpen(false);
    }
  }, [page]);

  useEffect(() => {
    if (!isLoading && data) {
      if (!error) {
        window.location.href = window.location.origin;
      }
    }
  }, [data, isLoading, error]);

  return (
    <>
      <button
        data-drawer-target="sidebar-multi-level-sidebar"
        data-drawer-toggle="sidebar-multi-level-sidebar"
        aria-controls="sidebar-multi-level-sidebar"
        type="button"
        className="inline-flex items-center p-2 mt-2 ml-3 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
      >
        <span className="sr-only">Open sidebar</span>
        <svg className="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path
            clipRule="evenodd"
            fillRule="evenodd"
            d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
          />
        </svg>
      </button>
      <aside id="sidebar-multi-level-sidebar" className="relative top-0 left-0 z-40 w-64 h-screen transition-transform -translate-x-full sm:translate-x-0" aria-label="Sidebar">
        <div className="h-full px-3 py-4 overflow-y-auto bg-gray-50 dark:bg-gray-800">
          <ULList {...{ page, setPage, auth, setJobMenuOpen, jobMenuOpen, members, logout, state }} />
        </div>
      </aside>
      <div className="md:hidden">
        <ULList {...{ page, setPage, auth, setJobMenuOpen, jobMenuOpen, members, logout, state, mobile: true }} />
      </div>
    </>
  );
};

export default Aside;

export const ULList = ({ page, setPage, auth, setJobMenuOpen, jobMenuOpen, members, logout, state, mobile = false }) => {
  return (
    <ul className={`space-y-2 font-medium ml-0 ${mobile ? "dark:bg-gray-700" : ""}`}>
      <li onClick={() => setPage("home")}>
        <a
          href="#"
          className={`flex hover:text-white hover:bg-[#224069] focus:text-white items-center p-2 text-gray-900 rounded-lg dark:text-white group ${
            page === "home" ? "!bg-[#224069] text-white dark:bg-gray-700" : ""
          }`}
        >
          <svg
            className="w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 22 21"
          >
            <path d="M16.975 11H10V4.025a1 1 0 0 0-1.066-.998 8.5 8.5 0 1 0 9.039 9.039.999.999 0 0 0-1-1.066h.002Z" />
            <path d="M12.5 0c-.157 0-.311.01-.565.027A1 1 0 0 0 11 1.02V10h8.975a1 1 0 0 0 1-.935c.013-.188.028-.374.028-.565A8.51 8.51 0 0 0 12.5 0Z" />
          </svg>
          <span className="ml-3">Dashboard</span>
        </a>
      </li>
      {!["administrator", "admin"].includes(auth?.role) && (
        <>
          <li onClick={() => setPage("profile")}>
            <a
              href="#"
              className={`flex hover:text-white hover:bg-[#224069] focus:text-white focus:text-white items-center p-2 text-gray-900 rounded-lg dark:text-white group ${
                page === "profile" ? "!bg-[#224069] text-white " : ""
              }`}
            >
              <svg
                className="w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 22 21"
              >
                <path d="M16.975 11H10V4.025a1 1 0 0 0-1.066-.998 8.5 8.5 0 1 0 9.039 9.039.999.999 0 0 0-1-1.066h.002Z" />
                <path d="M12.5 0c-.157 0-.311.01-.565.027A1 1 0 0 0 11 1.02V10h8.975a1 1 0 0 0 1-.935c.013-.188.028-.374.028-.565A8.51 8.51 0 0 0 12.5 0Z" />
              </svg>
              <span className="ml-3">Profile</span>
            </a>
          </li>
        </>
      )}
      <li onClick={() => setPage("members")}>
        <a
          href="#"
          className={`flex hover:text-white hover:bg-[#224069] focus:text-white items-center p-2 text-gray-900 rounded-lg dark:text-white group ${
            page === "members" ? "!bg-[#224069] text-white dark:bg-gray-700" : ""
          }`}
        >
          <svg
            className="w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 22 21"
          >
            <path d="M16.975 11H10V4.025a1 1 0 0 0-1.066-.998 8.5 8.5 0 1 0 9.039 9.039.999.999 0 0 0-1-1.066h.002Z" />
            <path d="M12.5 0c-.157 0-.311.01-.565.027A1 1 0 0 0 11 1.02V10h8.975a1 1 0 0 0 1-.935c.013-.188.028-.374.028-.565A8.51 8.51 0 0 0 12.5 0Z" />
          </svg>
          <span className="ml-3">Members</span>
        </a>
      </li>
      {["administrator", "admin"].includes(auth?.role) && (
        <li onClick={() => setPage("member-applications")}>
          <a
            href="#"
            className={`flex hover:text-white hover:bg-[#224069] focus:text-white items-center p-2 text-gray-900 rounded-lg dark:text-white group ${
              page === "member-applications" ? "!bg-[#224069] text-white dark:bg-gray-700" : ""
            }`}
          >
            <svg
              className="w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 22 21"
            >
              <path d="M16.975 11H10V4.025a1 1 0 0 0-1.066-.998 8.5 8.5 0 1 0 9.039 9.039.999.999 0 0 0-1-1.066h.002Z" />
              <path d="M12.5 0c-.157 0-.311.01-.565.027A1 1 0 0 0 11 1.02V10h8.975a1 1 0 0 0 1-.935c.013-.188.028-.374.028-.565A8.51 8.51 0 0 0 12.5 0Z" />
            </svg>
            <span className="ml-3 flex items-center">
              Applications
              <span className="w-6 5-3 bg-red-500 rounded-full text-white inline-flex items-center justify-center ml-2">{members?.filter((member) => !member.is_approved)?.length}</span>
            </span>
          </a>
        </li>
      )}
      <li>
        <a
          onClick={() => setJobMenuOpen(!jobMenuOpen)}
          className={`flex hover:text-white hover:bg-[#224069] focus:text-white items-center p-2 text-gray-900 rounded-lg dark:text-white group cursor-pointer`}
          aria-controls="dropdown-example"
          data-collapse-toggle="dropdown-example"
        >
          <svg
            className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 18 21"
          >
            <path d="M15 12a1 1 0 0 0 .962-.726l2-7A1 1 0 0 0 17 3H3.77L3.175.745A1 1 0 0 0 2.208 0H1a1 1 0 0 0 0 2h.438l.6 2.255v.019l2 7 .746 2.986A3 3 0 1 0 9 17a2.966 2.966 0 0 0-.184-1h2.368c-.118.32-.18.659-.184 1a3 3 0 1 0 3-3H6.78l-.5-2H15Z" />
          </svg>
          <span className="flex-1 ml-3 text-left whitespace-nowrap">Job Post</span>
          <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m1 1 4 4 4-4" />
          </svg>
        </a>
        <ul id="dropdown-example" className={`${jobMenuOpen ? "" : "hidden"} ml-0 py-2 space-y-2`}>
          <li onClick={() => setPage("jobs")}>
            <a
              href="#"
              className={`flex hover:text-white hover:bg-[#224069] focus:text-white items-center w-full p-2 text-gray-900 transition duration-75 rounded-lg pl-11 group dark:text-white ${
                page === "jobs" ? "!bg-[#224069] text-white dark:bg-gray-700" : ""
              }`}
            >
              All Jobs
            </a>
          </li>
          <li onClick={() => setPage("new-job-post")}>
            <a
              href="#"
              className={`flex hover:text-white hover:bg-[#224069] focus:text-white items-center w-full p-2 text-gray-900 transition duration-75 rounded-lg pl-11 group dark:text-white ${
                page === "new-job-post" ? "!bg-[#224069] text-white dark:bg-gray-700" : ""
              }`}
            >
              New Job Post
            </a>
          </li>
        </ul>
      </li>
      <li>
        <a href={"#"} className="flex hover:text-white hover:bg-[#224069] focus:text-white items-center p-2 text-gray-900 rounded-lg dark:text-white group">
          <svg
            className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 18 16"
          >
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M1 8h11m0 0L8 4m4 4-4 4m4-11h3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-3" />
          </svg>
          <span
            className="flex-1 ml-3 whitespace-nowrap"
            onClick={(e) => {
              e.preventDefault();
              logout({ nonce: state.nonce });
            }}
          >
            Sign Out
          </span>
        </a>
      </li>
      {!auth?.user.ID && (
        <li>
          <a href="#" className="flex hover:text-white hover:bg-[#224069] focus:text-white items-center p-2 text-gray-900 rounded-lg dark:text-white group">
            <svg
              className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 18 16"
            >
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M1 8h11m0 0L8 4m4 4-4 4m4-11h3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-3" />
            </svg>
            <span className="flex-1 ml-3 whitespace-nowrap">Sign In</span>
          </a>
        </li>
      )}
    </ul>
  );
};

{
  /* <li onClick={() => setPage("home")}>
                  <a href="#" className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white group">
                    <svg
                      className="w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 22 21"
                    >
                      <path d="M16.975 11H10V4.025a1 1 0 0 0-1.066-.998 8.5 8.5 0 1 0 9.039 9.039.999.999 0 0 0-1-1.066h.002Z" />
                      <path d="M12.5 0c-.157 0-.311.01-.565.027A1 1 0 0 0 11 1.02V10h8.975a1 1 0 0 0 1-.935c.013-.188.028-.374.028-.565A8.51 8.51 0 0 0 12.5 0Z" />
                    </svg>
                    <span className="ml-3">Dashboard</span>
                  </a>
                </li> */
}
